/**
 * Narrow the `permissions` field of `GET /api/auth/me` (v2.0 A8) to a clean
 * list of strings. The field is additive: an older API omits it, and the
 * session then carries no permissions, so every permission-gated surface stays
 * hidden (fail closed) instead of crashing. Anything that is not a non-empty
 * string is dropped; duplicates are collapsed.
 */
export function parsePermissions(value: unknown): readonly string[] {
  if (!Array.isArray(value)) return [];
  const clean = value.filter((p): p is string => typeof p === "string" && p.length > 0);
  return [...new Set(clean)];
}
